// CosmicBackground - Disabled for minimal writer-focused design
// Keeping component to avoid breaking imports

export function CosmicBackground() {
  // Return null - no animated backgrounds in minimal design
  return null;
}
